import React from 'react';
import classnames from 'classnames';
import { H2Alt, H3, Paragraph } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import {
  flex,
  column,
  tablet_row,
  centerContent,
  centerItems
} from 'scy/flex.mod.scss';
import { textCenter, plainList } from 'scy/utils.mod.scss';
import { tablet_block } from 'scy/display.mod.scss';
import { list, listItem, iconContainer, subtitle } from './styles.mod.scss';
import { insertCity } from 'components/CityPage/Reasons';

function ValueProps({ id, title, city, listItems }) {
  return (
    <section
      id={id}
      className={classnames(
        padding.sm,
        padding.tablet_top_lg,
        padding.tablet_bottom_lg,
        textCenter
      )}
    >
      <H2Alt
        marginClass={classnames(margin.top_0, margin.bottom_md)}
        className={classnames(tablet_block, padding.top_md)}
      >
        {title}
      </H2Alt>
      <ul
        className={classnames(
          flex,
          column,
          tablet_row,
          centerContent,
          centerItems,
          list,
          plainList,
          margin.sides_auto
        )}
      >
        <ListItems listItems={listItems} city={city} />
      </ul>
    </section>
  );
}

const ListItems = ({ listItems, city }) =>
  listItems.map(item => (
    <li key={`item-${item.title}`} className={listItem}>
      <div className={iconContainer}>{item.icon}</div>
      <H3 marginClass={margin.xs}>{insertCity(item.title, city)}</H3>
      <Paragraph className={subtitle}>
        {insertCity(item.subtitle, city)}
      </Paragraph>
    </li>
  ));

export default ValueProps;
